import Page from "../Common/Page";
import React from "react";
import { Row, Col, Divider, Space } from "antd";

export default class PasswordEndPage extends React.Component<any> {
  private _page: React.RefObject<Page>;
  constructor(props: any) {
    super(props);
    this._page = React.createRef<Page>();
  }

  render() {
    return (
      <Page ref={this._page} noCheckAuthority={true}>
        <Row justify="center">
          <Col span={6}>
            <h1 className="iiscore-title">iiscore-U</h1>
          </Col>
        </Row>
        <Row justify="center">
          <Col span={6}>
            <Divider orientation="left">パスワード再設定完了</Divider>
          </Col>
        </Row>

        <Row justify="center">
          <Col span={6}>
            <Space split={<Divider type="vertical" />} size={"large"}>
              パスワードの再設定は完了しました。入力したメールアドレスにパスワード変更URLをお送りしました。
            </Space>
          </Col>
        </Row>
        <Row justify="center">
          <Col span={6}>
            <Space split={<Divider type="vertical" />} size={"large"}>
              　
            </Space>
          </Col>
        </Row>
      </Page>
    );
  }
}
// export default withCookies(PasswordEndPage);
